export const VendorTypes = { 1: "Supplier", 2: "Finisher", 3: "Fullfilment" }